module.exports = __webpack_public_path__ + "static/media/ImagePlaceholder.d06ad1c9.svg";